export default "__VITE_ASSET__fOj018sm__"